/* eslint-disable no-unsafe-optional-chaining */
import React, { useCallback } from 'react';
import { Field, Form } from 'formik';
import { Button, Col, Row } from 'reactstrap';
import { ADD_EDIT_CONSTANT, dynamicButtonHeading } from 'utils/constants';
import { bannerCategoryOptions } from 'pages/ApplicationUI/constant';
import ReactSelect from 'components/Fields/ReactSelect';
import FormikInputField from 'components/Fields/FormikInputField';
import EditUploadWrapper from 'components/EditUploadWrapper';
import S3FileUploadField from 'components/S3FileUploadField';

const AddEditUploadPromoImageForm = (props) => {
  const {
    drawerToggle,
    handleSubmit,
    isSubmitting,
    isValid,
    dirty,
    type,
    values,
    setFieldValue,
  } = props;

  const handleCancel = useCallback(
    (val) => {
      setFieldValue(val, '');
    },
    [setFieldValue],
  );

  const handleChange = (newValue) => {
    setFieldValue('promotionType', newValue, true);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col sm={12}>
          <Field
            label="Banner Type/Category"
            name="promotionType"
            type="select"
            component={ReactSelect}
            data={bannerCategoryOptions}
            keys={{ id: 'id', label: 'label' }}
            isDisabled={type === ADD_EDIT_CONSTANT.EDIT}
            getOptionValue={(option) => option.id}
            getOptionLabel={(option) => option.label}
            onChange={handleChange}
            required
          />
        </Col>
      </Row>

      {values?.imageUrl ? (
        <EditUploadWrapper
          label="Banner Image"
          fileName={values.imageUrl}
          name="imageUrl"
          handleCancel={() => handleCancel('imageUrl')}
          required
          isLinkPath
        />
      ) : (
        <S3FileUploadField
          label="Banner Image"
          name="imageUrl"
          pathUrl="images/ui_settings/banner"
          accept=".png,.jpg,.jpeg,.gif"
          required
          containerName="public-assets"
        />
      )}

      <Row>
        <Col sm={12}>
          <Field
            id="redirectUrl"
            name="redirectUrl"
            type="text"
            label="URL"
            placeholder="Enter redirect URL"
            component={FormikInputField}
          />
        </Col>
      </Row>
      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          onClick={drawerToggle}
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
        >
          Cancel
        </Button>
        <Button
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
          className="mw-100"
        >
          {dynamicButtonHeading(type)}
        </Button>
      </div>
    </Form>
  );
};

export default AddEditUploadPromoImageForm;
